import { Box, Flex } from '@chakra-ui/react';
import { Fragment } from 'react';

import useIsLandScapeMachine from '@/hook/useIsLandScapeMachine';

import GameSelector from '../../components/GameComponents/GameSelector/GameSelector';
import GameTypeSelector from '../../components/GameComponents/GameTypeSelector/GameTypeSelector';
import PlatformSelectorRight from '../../components/GameComponents/PlatformSelector/PlatformSelectorRight';
import useDeviceType from '../../hook/useDeviceType';
import Seo from './seo';

const Live = ({ gameMainTypeFromProps } = {}) => {
  const isLandscapeMobile = useIsLandScapeMachine();

  const isMobile = useDeviceType() === 'Mobile';
  const isTablet = useDeviceType() === 'Tablet';

  return (
    <Fragment>
      <Seo />

      <Flex
        flex={1}
        direction={{
          base: 'column'
        }}
      >
        <Box
          position="sticky"
          top={{
            base: '55px',
            md: isLandscapeMobile ? '0' : '100px',
            xl: '125px'
          }}
          left="0px"
          mb={{
            base: '10px',
            md: 'unset'
          }}
          zIndex={1}
        >
          <PlatformSelectorRight
            gameMainTypeFromProps={gameMainTypeFromProps}
          />
        </Box>
        <Flex flex={1}>
          <Box
            py={{
              base: '0'
            }}
            display={{
              base: 'block',
              sm: 'none'
            }}
            pr="5px"
          >
            <GameTypeSelector gameMainTypeFromProps={gameMainTypeFromProps} />
          </Box>
          <Flex
            gap={{
              base: '0',
              md: '10px'
            }}
            py={{
              base: '0',
              md: 'home-space'
            }}
            px="common-y"
            mb={{
              base: '60px',
              sm: '0px'
            }}
            w={{
              base: '100%'
            }}
            flexDirection={{
              base: 'column',
              md: 'column'
            }}
            flex={1}
            align={'center'}
          >
            <Box
              flex={1}
              h="100%"
              w="100%"
              maxW={{
                md: isLandscapeMobile ? '100dvw' : 'calc(100dvw - 220px)'
              }}
              pb={{
                sm: '110px'
              }}
              overflowX="scroll"
            >
              <GameSelector
                hiddenTitle
                gameMainTypeFromProps={gameMainTypeFromProps}
                topLayout={!isMobile && !isTablet}
              />
            </Box>
          </Flex>
        </Flex>

        {/* <JackpotList fixed /> */}
      </Flex>
    </Fragment>
  );
};

export default Live;
